import React, { useState } from 'react'
import dummyImage from '../../assets/img/demo-image.png';
import { useDispatch, useSelector } from 'react-redux';
import bicep from '../../assets/img/modals/bicep.webp'
import heart from '../../assets/img/modals/heart.svg'
import rocket from '../../assets/img/modals/rocket.svg'
import { useEffect } from 'react';
import { apiUrl } from '../../utils/url';
const NewUpdateModal = () => {
    const dispatch = useDispatch();
    const showNewUpdateModal = useSelector(state => state?.newUpdatePopupReducer)
    const closeModal = () => dispatch({ type: 'SET_SHOW_NEW_UPDATE_POPUP', payload: false })
    const [data, setData] = useState({});
    if (!showNewUpdateModal) return null
    const callPopupData = async () => {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const res = await fetch(`${apiUrl}/popup`, {
            headers: myHeaders
        })
        const response = await res.json();
        return setData(response?.data)
    };
    useEffect(() => {
        callPopupData();
    }, [])
    return (
        <div className='new-update-main'>
            <div className="new-update-container">
                <div className="update-card">
                    <button onClick={closeModal} type="button" className="card-close-button" aria-label="Close">
                        ✕
                    </button>
                    {
                        data?.data ?
                            <div dangerouslySetInnerHTML={{ __html: data?.data }}></div>
                            :
                            <>
                                <div className="rocket-icon">
                                    <img src={rocket} alt="" />
                                </div>

                                <h2 className="text-center mb-4 font-weight-600">Important Updates</h2>

                                <div className="mb-2 fs-16px">
                                    <p className="mb-2">Hey there!</p>
                                    <p>We just dropped some juicy new features (plus a sprinkle of bug fixes) to level up your game:</p>
                                </div>

                                <ul className="feature-list mb-4">
                                    <li>Page Analytics</li>
                                    <li>Lead Import</li>
                                    <li>Custom Code + iFrame Block</li>
                                    <li>Custom Variable Import</li>
                                    <li>GPT 4.0 Integration</li>
                                    <li>Instantly & Google Sheets Integration</li>
                                </ul>

                                <p className="mb-4">As always, we're looking forward to your feedback on these new releases <img src={bicep} width={16} className='mb-1' alt="" srcset="" /></p>

                                <p className="mb-4">
                                    P.S. Bugs love hiding in the corners, so if you spot one, give us a shout at &nbsp;
                                    <a href="mailto:team@genpage.ai" className="email-link">team@genpage.ai</a>.
                                    We've got your back!
                                </p>

                                <p className="mb-2">With <img src={heart} width={16} className='mb-1' alt="" /></p>
                                <p className="fw-bold mb-0">GenPage Team</p>
                            </>
                    }

                </div>
            </div>
            <div className='dummy-bg-image'>
                <img src={dummyImage} alt="" srcset="" />
            </div>
        </div>
    )
}

export default NewUpdateModal